import type { PayslipStatus } from '@/api/client'
import { cn } from '@/lib/cn'
import { useTranslation } from 'react-i18next'

interface Props {
  status: PayslipStatus
  className?: string
}

export function PayslipStatusBadge({ status, className }: Props) {
  const { t } = useTranslation('payroll')
  const styles: Record<PayslipStatus, string> = {
    draft: 'bg-muted text-foreground',
    computed: 'bg-primary-muted text-primary',
    validated: 'bg-success/15 text-success',
    paid: 'bg-accent text-accent-foreground',
    cancelled: 'bg-destructive/10 text-destructive line-through',
  }
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium',
        styles[status],
        className,
      )}
    >
      {t(`payslip_status.${status}`, { defaultValue: status })}
    </span>
  )
}
